import React, { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import * as yup from 'yup';
import { useFormik, FormikProvider, FieldArray } from 'formik';
import { Box, Button } from '@mui/material';


import { useSnackbar } from 'notistack';
import * as techApi from '../../../lib/api/tech';
import * as fileApi from '../../../lib/api/file';
import { useDispatch, useSelector } from 'react-redux';
import { listProjectTechs } from '../../../modules/techModule/projectTechs';
import { setTech } from '../../../modules/techModule/tech';
import { listTechFiles } from '../../../modules/techModule/techFiles';
import SubTitleTemplate from '../../../components/common/template/SubTitleTemplate';
import TechMultiFileForm from '../../../components/techmng/support/TechMultiFileForm';
import TechRsltForm from '../../../components/techmng/support/TechRsltForm';
import TechCostListForm from '../../../components/techmng/support/TechCostListForm';
import TechApprovalFormContainer from '../approval/TechApprovalFormContainer';
import AskDialog from '../../../components/common/dialog/AskDialog';
import _ from 'lodash';
import TechApprovalContainer from './TechApprovalContainer';
import { setTechRslt, viewTechRslt } from '../../../modules/techModule/techRslt';
import { setTechPlan } from '../../../modules/techModule/techPlan';

const TechRsltEditContainer = ({ tech, techPlan }) => {
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [apprUuid, setApprUuid] = useState(null);
  const [visible, setVisible] = useState(false);
  const [message, setMessage] = useState(null);

  const onCancle = () => {
    setVisible(false);
  };

  const onConfirm = () => {
    setVisible(false);
  };

  const [initialValues, setInitialValues] = useState({
    rsltTitle: '',
    rsltTyp: '',
    rsltStrtDt: '', //작업 시작 일
    rsltStrtHr: '00', //작업 시작시간
    rsltEndDt: '',
    rsltEndHr: '00', //작업
    rsltTotTm: 0,
    rsltContext: '',
    rsltCosts: [{//소요비용
      costTyp: '',
      costVal: '',
      costDesc: '',
    }],
    files: [{ file: null, fileDesc: '' }]
  });

  const {
    techRslt,
    techRsltCostList,
    approvalList,
    approvalLine,
    user,
    techMidInfo,
  } = useSelector(({ techModule, auth }) => ({
    user: auth.user,
    techMidInfo: techModule.midTechs.techMidInfo,
    techRslt: techModule.techRslt.techRslt,
    techRsltCostList: techModule.techRslt.techRsltCostList,
    approvalList: techModule.techRslt.approvalList,
    approvalLine: techModule.techRslt.apprUuid,
  }));

  //tech의 workUuid를 가지고 rslt정보를 가져와야함.
  useEffect(() => {
    dispatch(viewTechRslt(tech.rsltUuid));
  }, [dispatch, tech]);

  useEffect(() => {
    if (approvalLine) {
      setApprUuid(approvalLine);
    }
  }, [approvalLine]);

  useEffect(() => {
    if (techRslt) {
      // eslint-disable-next-line react-hooks/exhaustive-deps

      const cloneTechRslt = _.cloneDeep(techRslt);
      const strTmArr = cloneTechRslt.rsltStrtTm.split(':');
      const endTmArr = cloneTechRslt.rsltEndTm.split(':');

      cloneTechRslt.rsltStrtHr = strTmArr[0];
      cloneTechRslt.rsltEndHr = endTmArr[0];

      cloneTechRslt.files = [{ file: null, fileDesc: '' }];
      cloneTechRslt.rsltCosts = techRsltCostList;
      setInitialValues(cloneTechRslt);

    }
  }, [techRslt, techRsltCostList]);


  const validationSchema = yup.object({
    rsltTitle: yup.string('').required('결과보고서명을 입력하세요'),
    rsltTyp: yup.string().required('결과보고서 종류를 선택하세요'),
    rsltStrtDt: yup
      .date()
      .required('작업 시작일을 입력하세요')
      .nullable()
      .default(undefined),
    rsltEndDt: yup
      .date()
      .required('작업 종료일을 입력하세요')
      .min(yup.ref('rsltStrtDt'), '작업 종료일을 확인하세요')
      .when('rsltStrtDt', (rsltStrtDt, schema) => {
        if (rsltStrtDt) return schema.required('작업 종료일을 입력하세요');
      })
      .nullable()
      .default(undefined),
    rsltContext: yup.string('').required('결과보고서 내용을 입력하세요'),
    rsltCosts: yup.array().of(
      yup.object().shape({
        costTyp: yup.string()
          .nullable()
          .when('costVal', (costVal, schema) => {
            if (costVal)
              return schema.required('비용종류를 선택하세요');
          }),
        costVal: yup.number('비용은 숫자만 가능합니다')
          .min(0, '비용을 확인하세요')
      })
    ),
  });

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: async (values, { setSubmitting }) => {
      setSubmitting(true);

      if (!apprUuid || apprUuid === 'undefined') {
        setMessage('결재선이 선택되지 않았습니다. 결재선을 선택하세요');
        setVisible(true);
        return;
      }

      //(1) rslt 등록
      //(3) file 업로드
      //(2) plan 3으로 상태업데이트=> API에서 처리함.
      //console.log(values, 'values');

      // console.log(dataToSubmit,'dataToSubmit');
      onSave(values);
      setSubmitting(false);
    },
  });

  const makeDataToSubmit = (values) => {
    let rsltStrHour = values.rsltStrtHr;
    let rsltEndHour = values.rsltEndHr;
    if (!(techPlan?.plnTyp.includes("장기"))) {
      rsltStrHour = values.rsltStrtHr ? values.rsltStrtHr + ':00:00' : '00:00:00';
      rsltEndHour = values.rsltEndHr ? values.rsltEndHr + ':00:00' : '00:00:00';
    }
    let techRsltData = {
      rsltUuid: techRslt?.rsltUuid,
      reqUuid: tech.reqUuid,
      prjUuid: tech.prjUuid,
      planUuid: tech.planUuid,
      rsltTitle: values.rsltTitle,
      rsltTyp: values.rsltTyp,
      rsltStrtDt: values.rsltStrtDt
        ? dayjs(values.rsltStrtDt).format('YYYY-MM-DD')
        : null,
      rsltStrtTm: rsltStrHour,
      rsltEndDt: values.rsltEndDt
        ? dayjs(values.rsltEndDt).format('YYYY-MM-DD')
        : null,
      rsltEndTm: rsltEndHour,
      rsltContext: values.rsltContext,
      rsltTotTm: values.rsltTotTm,
    };



    let dataToSubmit = {
      techRslt: techRsltData,
      techRsltCostList: (values.rsltCosts[0]?.costVal === null || values.rsltCosts[0]?.costVal === '') ? null : values.rsltCosts,
      apprUuid: apprUuid,
    };

    return dataToSubmit;
  };

  const onSave = async (values) => {
    const dataToSubmit = makeDataToSubmit(values);

    try {
      const res = await techApi.editRsltInfo(techRslt.rsltUuid, dataToSubmit);

      if (res.data.info) {
        if (values.files.length > 0 && values.files[0].file !== null) {
          values.files.forEach(value => {
            onFileSave(value, tech);
          })
        }


        dispatch(listTechFiles('tech', tech.reqUuid))
        dispatch(setTechPlan(res.data.info.techPlan));
        dispatch(setTechRslt(res.data.info));
        dispatch(setTech(res.data.info.techReq));
        dispatch(listProjectTechs(tech.prjUuid));

      }
      enqueueSnackbar('저장 성공', {
        variant: 'success',
      });
    } catch (err) {
      let message =
        err.response !== 'undefined' ? err.response?.data?.message : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const onFileSave = async (value, techReq) => {
    let formData = new FormData();
    formData.append('fileDt', value.file);
    formData.append('fileTyp', 'tech');
    formData.append('fileAttrVal1', tech.reqUuid);
    formData.append('fileAttrVal2', tech.prjUuid);
    formData.append('fileAttrVal3', "기술 지원 완료 보고");
    formData.append('fileDesc', value.fileDesc);


    try {
      const response = await fileApi.addFiles(formData);

      if (response.data.result === 'success') {
        enqueueSnackbar("기술 지원 완료 보고 업로드 성공", {
          variant: 'success',
        });
      }

    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  return (
    <div>
      <Box
        component="form"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          mt: 1,
        }}
        noValidate
        autoComplete="off"
        onSubmit={formik.handleSubmit}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            m: 1,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>

        <SubTitleTemplate title="완료 보고 상세">
          <TechRsltForm formik={formik} tech={tech} techPlan={techPlan} techMidInfo={techMidInfo} techRslt={techRslt} />
        </SubTitleTemplate>
        <SubTitleTemplate title="소요 비용 정보">
          <FormikProvider value={formik}>
            <TechCostListForm formik={formik} />
          </FormikProvider>
        </SubTitleTemplate>
        {techRslt?.crtUsr === user.usrUuid && techRslt?.rsltStatus === 'S' && (
          <SubTitleTemplate title="결재선 확인">
            <TechApprovalFormContainer
              apprUuid={apprUuid}
              setApprUuid={setApprUuid}
            />
          </SubTitleTemplate>
        )}

        <SubTitleTemplate title="결재 내역">
          <TechApprovalContainer approvalList={approvalList} />
        </SubTitleTemplate>

        <SubTitleTemplate title="첨부 서류">
          <FormikProvider value={formik}>
            <FieldArray name="files"
              render={arrayHelpers => (
                <Box sx={{

                }}>
                  <Box>
                    {formik.values?.files.map((f, index) => {
                      return (
                        <TechMultiFileForm
                          key={index}
                          file={f}
                          index={index}
                          touched={formik.touched}
                          errors={formik.errors}
                          handleChange={formik.handleChange}
                          handleBlur={formik.handleBlur}
                          handleRemove={() => arrayHelpers.remove(index)} />
                      )
                    })}
                  </Box>
                  <Box sx={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center', my: 2 }}>
                    <Button sx={{ mx: 2 }} color="secondary" variant="outlined" onClick={() => arrayHelpers.push({ fileDesc: '', file: null })}>파일 추가</Button>
                  </Box>
                </Box>

              )}

            >

            </FieldArray>
          </FormikProvider>
        </SubTitleTemplate>


        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-end',
            alignItems: 'center',
            m: 1,
          }}
        >
          <Button
            type="submit"
            color="primary"
            variant="contained"
            disabled={formik.isSubmitting}
          >
            저장
          </Button>
        </Box>
      </Box>
      <AskDialog
        visible={visible}
        title="확인"
        description={message}
        confirmText="확인"
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
    </div>
  )
}

export default TechRsltEditContainer